import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-getproductandcost',
  templateUrl: './getproductandcost.component.html',
  styleUrls: ['./getproductandcost.component.css']
})
export class GetproductandcostComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
